import { render, staticRenderFns } from "./modalVisualizarModelo.vue?vue&type=template&id=60f94beb&scoped=true&lang=pug&"
import script from "./modalVisualizarModelo.vue?vue&type=script&lang=js&"
export * from "./modalVisualizarModelo.vue?vue&type=script&lang=js&"
import style0 from "./modalVisualizarModelo.vue?vue&type=style&index=0&id=60f94beb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f94beb",
  null
  
)

export default component.exports